import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import IneligibleEntitiesGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/Ineligible/IneligibleEntitiesGrid';

import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import NoDataPlaceHolder, {
  NoDataIcon
} from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { NewBeaconFileIcon } from 'src/components/SvgIcons';

export const EntityNoDataPlaceHolder = (
  <Flex marginTop="71px" alignItems="center" justifyContent="center">
    <NoDataPlaceHolder
      title="Data currently unavailable"
      description="There is currently no data matching your selected criteria. Please try another query to view insights."
      icon={<NoDataIcon icon={<NewBeaconFileIcon />} />}
    />
  </Flex>
);

/**
 * Review tab, Summary page
 */
const IneligibleEntities = () => {
  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <IneligibleEntitiesGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default IneligibleEntities;
